import * as React from 'react';
// tslint:disable-next-line:no-var-requires
const shortid = require('shortid');
import * as FontAwesome from 'react-fontawesome';
import './table.css';
import { DataType } from './tableModels';

interface Props {
    object: RowObject;
    index?: string;
    sortOnThis?: (index: number) => void;
    sortingIndex: number;
    icon: string;
    cssClassName?: string;
}

// tslint:disable-next-line:no-empty-interface
interface State {
    //
}

interface RowObject {
    type: DataType;
    obj: string | number | boolean | JSX.Element;
    // tslint:disable-next-line
    f?: any;
    id?: number;
    cssClassName?: string;
}
class TableBodyRowObject extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.renderHeadRowObject = this.renderHeadRowObject.bind(this);
        this.callBack = this.callBack.bind(this);
        this.sortOnMe = this.sortOnMe.bind(this);
        this.state = {
            icon: ''
        };
    }

    callBack() {
        this.props.object.f(this.props.object.id);
    }

    sortOnMe() {
        if (this.props.index && this.props.sortOnThis) {
            this.props.sortOnThis(Number(this.props.index));
        }
    }

    renderHeadRowObject(props: Props) {
        if (props.object.type === DataType.string || DataType.number || DataType.boolean || DataType.element) {
            return (
                <div className="TableHeadRowObject" key={shortid.generate()}>
                    {props.object.obj}
                </div>
            );
        } else {
            return <div key={shortid.generate()} />;
        }
    }

    public render() {
        return (
            <th onClick={this.sortOnMe} className={this.props.cssClassName}>
                {this.renderHeadRowObject(this.props)}
                <FontAwesome name={this.props.icon} />
            </th>
        );
    }
}

export default TableBodyRowObject;



// WEBPACK FOOTER //
// ./src/components/table/tableHeadRowObject.tsx